import { Component, OnInit } from "@angular/core";
import { log } from "console";
import { QRCodeService } from "src/app/services/qrcode.service";
import { Config } from "src/app/utility/config";
//import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
@Component({
  selector: "app-my-qr-code",
  templateUrl: "./my-qr-code.component.html",
  styleUrls: ["./my-qr-code.component.scss"],
})
export class MyQrCodeComponent implements OnInit {
  // elementType = NgxQrcodeElementTypes.URL;
  //correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
  value = "qrtdata";
  qrtdata: any;
  qrOtp: any;
  countdown: number = 31;
  userType: any;
  userObj: any;
  constructor(private qrtapi: QRCodeService, private config: Config) {
    // value = this.qrtdata;
  }
  ngOnInit() {
    this.userObj = JSON.parse(localStorage.getItem("userObj"));

    this.userType = this.userObj.userInfo.role_Id;
    this.GetQRCOde();
    setInterval(() => {
      this.GetQRCOde();
    }, 15000); // 10000 milliseconds = 10 seconds
    this.startCountdown();
  }
  async startCountdown() {
    while (true) {
      for (let i = this.countdown; i > 0; i--) {
        this.countdown = i;
        await this.delay(1000);
      }
      // Countdown reached zero, perform any action here if needed
      this.countdown = 31; // Reset the countdown to 30 seconds
    }
  }

  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  IsAdminandguard() {
    if (this.userType === 0 || this.userType === 15) {
      return true;
    } else {
      return false;
    }
  }
  GetQRCOde() {
    this.qrtapi.getQRCode().subscribe(
      (res) => {
        console.log("res",res)
        this.qrtdata = res.result.qrCodeValue;
        this.qrOtp = res.result.qrOtp;
        console.log("qr", this.qrOtp)
      },
      (error) => {
        console.error("Error fetching QR code:", error);
        this.config.stopLoader();
      }
    );
  }
}
